import { Directive, Optional, Inject, ViewContainerRef, ComponentFactoryResolver, ComponentRef, Input, Host, createComponent } from "@angular/core";
import { NgControl, ControlContainer } from "@angular/forms";
import { FORM_ERRORS } from "./form-errors";
import { ControlErrorComponent } from "./control-error/control-error.component";
import { ControlErrorContainerDirective } from "./control-error-container.directive";
import { FormSubmitDirective } from "./form-submit.directive";
import { merge, EMPTY, Observable } from "rxjs";

@Directive({
  selector: "[formControl], [formControlName]",
  standalone: false,
})
export class ControlErrorsDirective {
  ref: ComponentRef<ControlErrorComponent>;
  container: ViewContainerRef;
  submit$: Observable<Event>;
  @Input() customErrors = {};

  constructor(
    private vcr: ViewContainerRef,
    @Optional() controlErrorContainer: ControlErrorContainerDirective,
    @Inject(FORM_ERRORS) private errors,
    @Optional() @Host() private form: FormSubmitDirective,
    private controlDir: NgControl
  ) {
    this.container = controlErrorContainer ? controlErrorContainer.vcr : vcr;
    this.submit$ = this.form ? this.form.submit$ : EMPTY;
  }

  ngOnInit() {
    merge(this.submit$, this.control?.valueChanges)
      .pipe()
      .subscribe((v) => {
        const controlErrors = this.control?.touched ? this.control?.errors : undefined;
        if (controlErrors) {
          const firstKey = Object.keys(controlErrors)[0];
          const getError = this.errors[firstKey];
          const text = this.customErrors[firstKey] || getError(controlErrors[firstKey]);
          this.setError(text);
        } else if (this.ref) {
          this.setError(null);
        }
      });
  }

  get control() {
    return this.controlDir?.control;
  }

  setError(text: string) {
    if (!this.ref) {
      this.ref = this.container.createComponent(ControlErrorComponent);
      //this.ref = createComponent(ControlErrorComponent,{environmentInjector: this.container.injector}); //this.container.createComponent(factory);
    }

    this.ref.instance.text = text;
  }

  ngOnDestroy() {}
}
